/*!
 * Music Forecast — Quick Dig v1.0
 * Opens the inert product-card payload in a persistent side drawer.
 * No network request; works after soft navigation/filter/sort via delegation.
 */
(function () {
  'use strict';
  if (window.__mfQuickDig) return;
  window.__mfQuickDig = true;

  var root = document.getElementById('mf-quick-dig');
  if (!root) return;
  var slot = root.querySelector('[data-mf-quick-dig-content]');
  var closeBtn = root.querySelector('.mf-qd__close');
  var opener = null;

  function open(button) {
    var card = button && button.closest('[data-product-grid-item], .mf-highly-cardmeta');
    var tpl = card && card.querySelector('template[data-mf-quick-dig-template]');
    if (!tpl || !slot) return;
    slot.innerHTML = '';
    slot.appendChild(tpl.content.cloneNode(true));
    opener = button;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mf-quick-dig-open');
    if (closeBtn) requestAnimationFrame(function () { closeBtn.focus(); });
  }

  function close(restoreFocus) {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mf-quick-dig-open');
    if (slot) slot.innerHTML = '';
    if (restoreFocus !== false && opener && document.documentElement.contains(opener)) {
      try { opener.focus(); } catch (e) {}
    }
    opener = null;
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('[data-mf-quick-dig-open]');
    if (!button) return;
    e.preventDefault();
    e.stopPropagation();
    open(button);
  }, true);

  root.addEventListener('click', function (e) {
    var closeTarget = e.target.closest && e.target.closest('[data-mf-quick-dig-close]');
    if (closeTarget) {
      e.preventDefault();
      close(true);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) {
      e.preventDefault();
      close(true);
    }
  });

  /* A View Record link can use mf-softnav. Close only after the new page is ready,
     so the existing page never flashes underneath during navigation. */
  document.addEventListener('mf:softnav', function () { close(false); });
})();
